import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/context/LanguageContext";
import { getProductById } from "@/data/menu";
import { localize, formatTRY, defaultSelections } from "@/lib/format";

// Compact cross-sell rail used in the product sheet and cart.
export function UpsellSuggestions({ ids = [], title, testId = "upsell" }) {
  const { addItem } = useCart();
  const { lang, t } = useLang();

  const products = ids.map(getProductById).filter((p) => p && p.available);
  if (!products.length) return null;

  const quickAdd = (product) => {
    addItem({ productId: product.id, quantity: 1, selections: defaultSelections(product), note: "" });
    toast.success(`${localize(product.name, lang)} — ${t("add")}`);
  };

  return (
    <div data-testid={testId}>
      <h3 className="mb-2.5 font-heading text-base font-bold">{title || t("upsellTitle")}</h3>
      <div className="no-scrollbar flex gap-3 overflow-x-auto pb-1">
        {products.map((p) => (
          <div
            key={p.id}
            className="flex w-36 shrink-0 flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-soft"
            data-testid={`upsell-item-${p.id}`}
          >
            <div className="h-20 w-full overflow-hidden bg-muted">
              <img src={p.image} alt="" className="h-full w-full object-cover" loading="lazy" />
            </div>
            <div className="flex flex-1 flex-col p-2.5">
              <p className="line-clamp-1 text-xs font-bold">{localize(p.name, lang)}</p>
              <div className="mt-1.5 flex items-center justify-between">
                <span className="text-xs font-extrabold">{formatTRY(p.basePrice)}</span>
                <button
                  onClick={() => quickAdd(p)}
                  className="grid h-7 w-7 place-items-center rounded-full brand-gradient text-white active:scale-90"
                  aria-label={t("add")}
                  data-testid={`upsell-add-${p.id}`}
                >
                  <Plus className="h-4 w-4" strokeWidth={2.5} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
